exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".embed-carousel-wrapper[data-v-396ef1f2]{width:100%;padding-bottom:10px}", ""]);

// exports
